import { z } from 'zod';
/**
 * Connection lifecycle. The admin UI renders the badge differently per
 * state; `error` triggers the inline error-log panel.
 *
 *   - `disconnected`: never connected, or unsubscribe ran. No tokens.
 *   - `installing`: OAuth dance in flight (callback not yet hit).
 *   - `active`: tokens valid, last ingest succeeded.
 *   - `backfilling`: tokens valid, historical backfill in progress.
 *   - `error`: last sync failed; the orgConnectors.errorLog has the trail.
 *   - `paused`: admin clicked unsubscribe; historical data retained.
 */
export const CONNECTOR_STATUSES = [
    'disconnected',
    'installing',
    'active',
    'backfilling',
    'error',
    'paused',
];
export const ConnectorStatus = z.enum(CONNECTOR_STATUSES);
/**
 * One row in the per-connector error log. Capped to last N entries so
 * the doc doesn't grow unbounded; the store enforces the cap on write.
 */
export const ConnectorErrorEntry = z.object({
    at: z.string(),
    /** Short machine code — `oauth_failed`, `webhook_unauthorized`, `ingest_failed`, etc. */
    code: z.string().min(1).max(64),
    /** One-line operator-facing message. */
    message: z.string().min(1).max(500),
});
